import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const CHIPS_AREA_HEIGHT = "72px";

export const PromptsInputWrapper = styled(Flex)`
    flex-direction: column;
    gap: 8px;
`;

export const GradientWrapper = styled(Flex)`
    background: linear-gradient(180deg, ${colorsPalettes.bluegrey[100]} 0%, ${colorsPalettes.carbon[0]} 100%);
    border-radius: 4px;
    padding: 12px;
    margin-top: 4px;
`;

export const ChipsRow = styled(Flex)`
    height: ${CHIPS_AREA_HEIGHT};
    overflow: hidden;
`;

export const SuggestedTopicChipWrapper = styled.button<{ $disabled: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 4px 4px 4px 12px;
    background-color: ${colorsPalettes.carbon[0]};
    background-image: none;
    border: 1px solid ${({ $disabled }) => colorsPalettes.carbon[$disabled ? 50 : 100]};
    border-radius: 40px;
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    transition: border-color 0.2s ease;

    ${({ $disabled }) =>
        !$disabled &&
        `
        &:hover {
            border-color: transparent;
            background-image:
                linear-gradient(${colorsPalettes.carbon[0]}, ${colorsPalettes.carbon[0]}),
                linear-gradient(90deg, ${colorsPalettes.blue[400]} 0%, ${colorsPalettes.mint[400]} 100%);
            background-origin: border-box;
            background-clip: padding-box, border-box;
        }
    `}
`;
